export default {"src":"/_next/static/media/defaultBigSalvage.640716c3.svg","height":125,"width":218};